<script setup lang="ts">
import { Monitor, Moon, Sun } from 'lucide-vue-next';
import { setTheme, theme } from './theme';
import type { Theme } from './theme';

/**
 * Three segments rather than a switch, because there are three states and a
 * switch can only show two — "follow the machine" has to be reachable or a
 * reader who tries the toggle can never get back to it.
 *
 * A radio group, not buttons: this is one choice among three, and that is what
 * a screen reader should hear.
 */
const OPTIONS: readonly { value: Theme; label: string; icon: typeof Sun }[] = [
	{ value: 'light', label: 'Light', icon: Sun },
	{ value: 'dark', label: 'Dark', icon: Moon },
	{ value: 'system', label: 'System', icon: Monitor },
];
</script>

<template>
	<div
		role="radiogroup"
		aria-label="Colour theme"
		class="border-border inline-flex rounded-md border p-0.5"
	>
		<button
			v-for="option in OPTIONS"
			:key="option.value"
			type="button"
			role="radio"
			:aria-checked="theme === option.value"
			:aria-label="option.label"
			:title="option.label"
			class="rounded px-2 py-1"
			:class="
				theme === option.value ? 'bg-accent text-accent-fg' : 'text-muted hover:text-fg'
			"
			@click="setTheme(option.value)"
		>
			<component :is="option.icon" :size="15" aria-hidden="true" />
		</button>
	</div>
</template>
